export default "__VITE_ASSET__18f97af5__"